import React from "react";

import InsertLinkIcon from '@mui/icons-material/InsertLink';
import TitleIcon from '@mui/icons-material/Title';
import GroupsIcon from '@mui/icons-material/Groups';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

import discord from '../../assets/images/remix_icons/discord.svg';
import email from '../../assets/images/remix_icons/email.svg';
import facebook from '../../assets/images/remix_icons/facebook.svg';
import instagram from '../../assets/images/remix_icons/instagram.svg';
import linkedin from '../../assets/images/remix_icons/linkedin.svg';
import soundcloud from '../../assets/images/remix_icons/soundcloud.svg';
import spotify from '../../assets/images/remix_icons/spotify.svg';
import telegram from '../../assets/images/remix_icons/telegram.svg';
import tiktok from '../../assets/images/remix_icons/tiktok.svg';
import website from '../../assets/images/remix_icons/website.svg';
import x from '../../assets/images/remix_icons/x.svg';
import youtube from '../../assets/images/remix_icons/youtube.svg';
import bandcamp from '../../assets/images/remix_icons/bandcamp.svg';
import whatsapp from '../../assets/images/remix_icons/whatsapp.svg';

import EmbedIcon from "components/icons/EmbedIcon";
import LinkIcon from "components/icons/LinkIcon";
import HeaderIcon from "components/icons/HeaderIcon";
import CalendarIcon from "components/icons/CalendarIcon";
import TextIcon from "components/icons/TextIcon";

export const emptyPageElement = {
    content: "",
    image_file: null,
    element_type: "",
    reward_ids: ["public"],
    link_title: "",
};

export const pageElementTypes = [
  {
    value: 'link',
    title: 'Link',
    icon: InsertLinkIcon,
  },
  {
    value: "social",
    title: 'Social',
    icon: GroupsIcon,
  },
  {
    value: 'title',
    title: 'Section Header',
    icon: TitleIcon,
  },
  {
    value: 'embed',
    title: 'Embed',
    icon: PlayCircleOutlineIcon,
  },
];

export const socialTypes = [
  {
    value: "facebook",
    title: "Facebook",
    logo: facebook,
    color: "#1877F2",
  },
  {
    value: "x",
    title: "X",
    logo: x,
    color: "#000000",
  },
  {
    value: "instagram",
    title: "Instagram",
    logo: instagram,
    color: "#E1306C",
  },
  {
    value: "youtube",
    title: "Youtube",
    logo: youtube,
    color: "#FF0000",
  },
  {
    value: "linkedin",
    title: "Linkedin",
    logo: linkedin,
    color: "#0077B5",
  },
  {
    value: "tiktok",
    title: "TikTok",
    logo: tiktok,
    color: "#000000",
  },
  {
    value: "whatsapp",
    title: "WhatsApp",
    logo: whatsapp,
    color: "#25D366",
  },
  {
    value: "telegram",
    title: "Telegram",
    logo: telegram,
    color: "#0088cc",
  },
  {
    value: "discord",
    title: "Discord",
    logo: discord,
    color: "#5865F2",
  },
  {
    value: "spotify",
    title: "Spotify",
    logo: spotify,
    color: "#1DB954",
  },
  {
    value: "soundcloud",
    title: "SoundCloud",
    logo: soundcloud,
    color: "#FF8800",
  },
  {
    value: "bandcamp",
    title: "Bandcamp",
    logo: bandcamp,
    color: "#6296CC",
  },
  {
    value: "email",
    title: "Email",
    logo: email,
    color: "#000000",
  },
  {
    value: "website",
    title: "Website",
    logo: website,
    color: "#000000",
  },
];

export const embedTypes = [
  {
    value: "youtube_embed",
    title: "Youtube",
    logo: youtube,
  },
  {
    value: "spotify_embed",
    title: "Spotify",
    logo: spotify,
  },
  {
    value: "soundcloud_embed",
    title: "SoundCloud",
    logo: soundcloud,
  },
]

export const calendarViewOptions = [
  {
    label: "Compact",
    value: "list"
  },
  {
    label: "Extended",
    value: "extended"
  },
  {
    label: "Grid",
    value: "grid"
  },
];

export const possibleSettings = ["number_of_events", "view", "hide_price", "hide_location"];

export const ELEMENT_TYPE_LABELS = {
  embedded: "Embedded Media",
  title: "Header",
};

export const COLORS = {
  link: "#3b82f6",
  title: "#9333ea",
  text: "#10b981",
  calendar: "#f97316",
  embed: "#ec4899",
};

export const ICONS = {
  link: <LinkIcon />,
  title: <HeaderIcon />,
  text: <TextIcon />,
  calendar: <CalendarIcon />,
  embed: <EmbedIcon />,
};

export const originalBlockTypes = [
  {
    type: "link",
    label: "Link",
    description: "A clickable link to any URL",
  },
  {
    type: "title",
    label: "Header",
    description: "A section title or divider",
  },
  {
    type: "text",
    label: "Text",
    description: "A block of text content",
  },
  {
    type: "embed",
    label: "Embed",
    description: "Embed content like YouTube videos",
  },
];

export const calendarBlockType = {
  type: "calendar",
  label: "Calendar",
  description: "A calendar of events",
};